<template>
   <el-dialog
      :title="dialogTitle"
      v-model="dialogVisible"
      width="620px"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      custom-class="link-campus-dialog"
      @close="handleClose"
   >
      <!-- 非编辑：校区名横向排列、空格式间隔、自动换行；内容过多时区域可滚动 -->
      <div v-if="!isEdit" class="link-campus-body link-campus-body--view">
         <div v-if="viewCampusScope === 'all'" class="link-campus-all-hint">全部校区</div>
         <div v-else class="link-campus-view-scroll">
            <template v-if="campusModels.length">
               <span
                  v-for="(m, i) in campusModels"
                  :key="m.unid || i"
                  class="link-campus-view-name"
               >{{ m.name }}<template v-if="i < campusModels.length - 1">、</template></span>
            </template>
            <div v-else class="link-campus-empty">暂无关联校区</div>
         </div>
      </div>

      <!-- 编辑 -->
      <div v-else class="link-campus-body link-campus-body--edit">
         <el-form label-position="left" label-width="100px">
            <el-form-item>
               <template slot="label">
                  <span class="required">*</span> 适用校区
               </template>
               <el-radio-group v-model="campusScope">
                  <el-radio label="all">全部</el-radio>
                  <el-radio label="partial">部分校区</el-radio>
               </el-radio-group>
               <div v-if="campusScope === 'partial'" class="campus-partial">
                  <div class="campus-select-row">
                     <el-select
                        v-model="campusForm.unid"
                        placeholder="请选择校区"
                        filterable
                        class="campus-select"
                     >
                        <el-option
                           v-for="item in campusZoneList"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value"
                        />
                     </el-select>
                     <el-button type="primary" class="campus-add-btn" @click="handleAddCampus">添加</el-button>
                  </div>
                  <div class="campus-card-wrap">
                     <div
                        v-for="item in campusModels"
                        :key="item.unid"
                        class="campus-dialog-item"
                     >
                        <span>{{ item.name }}</span>
                        <el-button type="text" icon="circle-close" @click="handleDeleteCampus(item.unid)"></el-button>
                     </div>
                  </div>
                  <div class="campus-card-footer">共计{{ campusModels.length }}所学校</div>
               </div>
            </el-form-item>
         </el-form>
      </div>

      <span slot="footer" class="dialog-footer link-campus-footer">
         <template v-if="!isEdit">
            <el-button type="primary" @click="enterEdit">编辑</el-button>
         </template>
         <template v-else>
            <el-button @click="cancelEdit">取消</el-button>
            <el-button type="primary" @click="handleSave">保存</el-button>
         </template>
      </span>
   </el-dialog>
</template>

<script>
const API_SUCCESS = 10000;

export default {
   name: "LinkCampusDialog",
   props: {
      campusZoneList: {
         type: Array,
         default: () => [],
      },
   },
   data() {
      return {
         dialogVisible: false,
         isEdit: false,
         currentRow: null,
         campusScope: "all",
         campusModels: [],
         campusForm: { unid: "" },
         snapshot: { campusScope: "all", campusModels: [] },
      };
   },
   computed: {
      dialogTitle() {
         return this.isEdit ? "编辑关联校区" : "适用校区";
      },
      /** 查看态展示用：全部 / 部分 */
      viewCampusScope() {
         return this.campusScope;
      },
   },
   methods: {
      show(row) {
         this.currentRow = row || null;
         this.isEdit = false;
         this.syncFromRow();
         this.snapshot = {
            campusScope: this.campusScope,
            campusModels: JSON.parse(JSON.stringify(this.campusModels)),
         };
         this.campusForm.unid = "";
         this.dialogVisible = true;
      },
      syncFromRow() {
         const row = this.currentRow;
         if (!row) {
            this.campusScope = "all";
            this.campusModels = [];
            return;
         }
         const models = this.normalizeCampusModels(row.campusModels || row.campusList || []);
         if (row.campusScope === "all" || row.campusScope === "partial") {
            this.campusScope = row.campusScope;
         } else if (models.length > 0) {
            this.campusScope = "partial";
         } else {
            const scopeStr = row.scope || "";
            if (scopeStr.includes("全校")) {
               this.campusScope = "all";
            } else if (scopeStr.includes("校区") || scopeStr.includes("已配置")) {
               this.campusScope = "partial";
            } else {
               this.campusScope = "all";
            }
         }
         this.campusModels = models;
      },
      normalizeCampusModels(list) {
         if (!list || !list.length) return [];
         return list.map((item) => ({
            unid: item.unid != null ? item.unid : item.value,
            name: item.name != null ? item.name : item.label,
         }));
      },
      enterEdit() {
         this.syncFromRow();
         this.snapshot = {
            campusScope: this.campusScope,
            campusModels: JSON.parse(JSON.stringify(this.campusModels)),
         };
         this.campusForm.unid = "";
         this.isEdit = true;
      },
      cancelEdit() {
         this.campusScope = this.snapshot.campusScope;
         this.campusModels = JSON.parse(JSON.stringify(this.snapshot.campusModels));
         this.campusForm.unid = "";
         this.isEdit = false;
      },
      handleAddCampus() {
         if (!this.campusForm.unid) return;
         const exists = this.campusModels.some((x) => String(x.unid) === String(this.campusForm.unid));
         if (exists) return;
         const f = this.campusZoneList.find((item) => String(item.value) === String(this.campusForm.unid));
         if (!f) return;
         this.campusModels.push({ unid: f.value, name: f.label });
         this.campusForm.unid = "";
      },
      handleDeleteCampus(unid) {
         this.campusModels = this.campusModels.filter((x) => String(x.unid) !== String(unid));
      },
      handleSave() {
         if (this.campusScope === "partial" && !this.campusModels.length) {
            return this.$message.warning("请至少选择一所学校");
         }
         if (!this.currentRow || this.currentRow.id == null) {
            return this.$message.warning("策略信息缺失");
         }
         const campusScopeNum = this.campusScope === "all" ? 1 : 2;
         const campusIds =
            this.campusScope === "all"
               ? []
               : this.campusModels.map((m) => Number(m.unid)).filter((n) => !Number.isNaN(n));
         this.$http({
            url: `${this.$util.domain}/adminapi/v1/ad/strategy/${this.currentRow.id}/campus`,
            method: "POST",
            dataType: "json",
            body: JSON.stringify({
               campusScope: campusScopeNum,
               campusIds,
               operator: 0,
            }),
         })
            .then((res) => {
               if (res.body.error !== API_SUCCESS) {
                  this.$message({
                     type: "error",
                     message: res.body.message || "保存失败",
                  });
                  return;
               }
               const scopeText =
                  this.campusScope === "all" ? "全校" : `已配置 ${this.campusModels.length} 个校区`;
               this.$emit("saved", {
                  row: this.currentRow,
                  campusScope: this.campusScope,
                  campusModels: JSON.parse(JSON.stringify(this.campusModels)),
                  scopeText,
               });
               this.$message({
                  type: "success",
                  message: "操作成功!",
               });
               this.snapshot = {
                  campusScope: this.campusScope,
                  campusModels: JSON.parse(JSON.stringify(this.campusModels)),
               };
               this.isEdit = false;
               this.dialogVisible = false;
            })
            .catch(() => {
               this.$message({
                  type: "error",
                  message: "操作失败，请稍后再试!",
               });
            });
      },
      handleClose() {
         this.isEdit = false;
         this.currentRow = null;
         this.campusScope = "all";
         this.campusModels = [];
         this.campusForm.unid = "";
      },
   },
};
</script>

<style scoped>
.required {
   color: #f56c6c;
   font-weight: 600;
   margin-right: 4px;
}

.link-campus-body {
   min-height: 120px;
}

.link-campus-body--view .link-campus-view-scroll {
   box-sizing: border-box;
   max-height: 420px;
   overflow-y: auto;
   padding: 10px;
   border: 1px solid #c0ccda;
   border-radius: 4px;
   background: #fff;
   font-size: 13px;
   line-height: 1.65;
   color: #303133;
   word-break: break-all;
   white-space: normal;
}

.link-campus-view-name {
   display: inline;
}

.link-campus-all-hint {
   font-size: 14px;
   color: #303133;
   padding: 12px 0;
   text-align: center;
}

.link-campus-empty {
   color: #909399;
   font-size: 14px;
   padding: 16px;
   text-align: center;
}

.campus-partial {
   margin-top: 10px;
}

.campus-select-row {
   display: flex;
   align-items: center;
   gap: 16px;
   margin-bottom: 10px;
   padding-right: 18px;
}

.campus-select {
   flex: 0 0 84%;
   max-width: 84%;
}

.campus-add-btn {
   min-width: 84px;
   height: 40px;
   padding: 0 20px;
   font-size: 16px;
   margin-left: 4px;
   margin-right: 6px;
}

/* 与 AdAddStrategyDialog 中 campus-card-wrap / campus-dialog-item 一致 */
.campus-card-wrap {
   box-sizing: border-box;
   width: 100%;
   height: 200px;
   overflow: auto;
   padding: 10px;
   margin: 8px 0 4px;
   border: 1px solid #c0ccda;
   border-radius: 4px;
   display: flex;
   flex-wrap: wrap;
   align-content: flex-start;
   gap: 8px;
   font-size: 14px;
   line-height: 1.5;
}

.campus-dialog-item {
   display: inline-flex;
   align-items: center;
   gap: 6px;
   border: 1px solid #c0ccda;
   border-radius: 4px;
   padding: 4px 6px;
   font-size: 13px;
   line-height: 1.3;
   background: #fff;
}

.campus-card-footer {
   text-align: right;
   color: #909399;
   font-size: 13px;
   margin-top: 8px;
}

.link-campus-footer {
   display: flex;
   justify-content: center;
   align-items: center;
   gap: 12px;
}
</style>



// WEBPACK FOOTER //
// LinkCampusDialog.vue?d32da8be